import { useNavigate } from "react-router-dom";
import Cart from "../Cart/Cart";
import Header from "../Header/Header";
import Product from "../Product/Product";
import ProductModal from "../ProductModal/ProductModal";
import { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import { getService } from "../GenericServices/genericService";
import CategoryFilter from "../CategoryFilter/CategoryFilter";

const Products = ({
  addToCart,
  cart,
  pathname,
  total,
  removeFromCart,
  pathLocation,
}) => {
  const [selectedCategory, setSelectedCategory] = useState({
    id: 0,
    cat_name: "All",
    cat_title: "All",
  });
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false);
  const [consoleProducts, setConsoleProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // useEffect(() => {
  //   const filter = consoleProducts.filter((product) => {
  //     return product.cat_id === selectedCategory.id;
  //   });

  //   if (filter.length > 0) {
  //     setFilteredProducts([...filter]);
  //   } else {
  //     setFilteredProducts([...consoleProducts]);
  //   }
  // }, [selectedCategory]);

  useEffect(() => {
    getProductAPI();
  }, []);

  /* Get Products API */
  const getProductAPI = () => {
    // Implement API call to fetch products and setProducts
    const url = "myNewAPI/get_product.php";
    getService(url, {}, getProductData);
  };

  const getProductData = (response) => {
    const data = response.product.map((item, index) => {
      return {
        ...item,
        prod_id: index + 1,
      };
    });
    setFilteredProducts(data);
    setConsoleProducts(data);
  };

  /* Changing Category  */
  const changeCategory = (category) => {
    const filter = consoleProducts.filter((product) => {
      return +product.cat_id === +category.id;
    });
    setSelectedCategory(category);
    if (filter.length > 0) {
      setFilteredProducts([...filter]);
    } else {
      setFilteredProducts([...consoleProducts]);
    }
  };

  console.log("filteredProducts:", filteredProducts);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        cartCount={cart.length}
        onCartClick={() => setCartOpen(true)}
        searchTerm=""
        setSearchTerm={() => {}}
        pathname={pathLocation}
        navigate={navigate}
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 via-purple-600 to-pink-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-black mb-6">
            All Gaming Products
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Discover all our gaming products including consoles and games,
            categorized for easy browsing
          </p>
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <CategoryFilter
          selectedCategory={selectedCategory}
          onCategoryChange={changeCategory}
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {filteredProducts.map((product) => (
            <Product
              key={product.prod_id}
              product={product}
              onAddToCart={addToCart}
              onProductClick={setSelectedProduct}
            />
          ))}
        </div>
      </main>

      <Footer />
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onAddToCart={addToCart}
        />
      )}
      {cartOpen && (
        <Cart
          cart={cart}
          total={total}
          onRemove={removeFromCart}
          onClose={() => setCartOpen(false)}
          onCheckout={() => {
            navigate("/checkout");
            setCartOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default Products;
